<div class="cart-list-item-price">
  <div class="text-b1-m-900 text-lg-b1-l-900 color-black">
    {{ totalPrice() }}
    @if (isRent()) {
      <span class="text-b3-s-300 text-lg-b2-s-300">/24 ч</span>
    }
  </div>
  <div class="text-c1-s-500 text-md-b4-s-500 text-lg-b3-s-500 color-black-warm-400">
    {{ unitPrice() }}
  </div>
</div>
